export default async function getFirstFrame(videoSrc: string) {
  return new Promise<string>((resolve, reject) => {
    // Create hidden video and canvas elements dynamically
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    video.crossOrigin = 'use-credentials';

    // Handle video loaded data
    video.addEventListener('loadeddata', () => {
      video.currentTime = 0; // Seek to first frame
    });

    // Handle seeking to first frame
    video.addEventListener('seeked', () => {
      // Set canvas dimensions to match the video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw the first frame of the video to the canvas
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas to a base64 image URL and resolve the promise
      const imageUrl = canvas.toDataURL('image/png');
      resolve(imageUrl); // Return the image URL
    });

    // Handle error loading video
    video.addEventListener('error', (e) => {
      reject(new Error(`Error loading video: ${e.message}`));
    });

    // Set the video source and trigger the loading process
    video.src = videoSrc;
    video.load();
    video.muted = true; // Prevent playing audio if it auto-plays
  });
}
